import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

class Select extends Component {
    render() {
        let ret = [];
        let keys = Object.keys(this.props.array).sort();
        for (let key in keys) {
            ret.push(
                <option key={key} value={keys[key]}>
                    {this.props.array[keys[key]]}
                </option>
            );
        }
        return (
            <Body onChange={this.props.onChange} value={this.props.value} style={this.props.style}>
                {ret}
            </Body>
        )
    }
}

export { Select };

Select.propTypes = {
    array: PropTypes.object.isRequired,
    style: PropTypes.object,
    value: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired,
};

const Body = styled.select`
    border: 1px solid #888;
    color: #888;
    padding: 3px 5px 3px 5px;
    border-radius: 5px;
    outline: none;
    margin: 0 10px;
    option:first-of-type {
        border-radius: 5px 5px 0 0;
    }
    option:last-of-type {
        border-radius: 0 0 5px 5px;
    }
`;